<div class="donut-chart-container" (mousemove)="onChartMouseMove($event)">
  <ngx-charts-pie-chart
    [results]="normalized()"
    [customColors]="finalColors()"
    [doughnut]="true"
    [legend]="showLegend"
    [labels]="false"
    [arcWidth]="arcWidth"
    [tooltipDisabled]="true"
    [animations]="false"
    (activate)="onActivate($event)"
    (deactivate)="onDeactivate()">
  </ngx-charts-pie-chart>

  @if (tooltipVisible) {
    <div class="donut-tooltip"
         [ngStyle]="{ top: tooltipY + 'px', left: tooltipX + 'px' }">
      {{ tooltipText }}
    </div>
  }
</div>
